var map = {
	"./star1.webp": "c2bb",
	"./star1_sm.webp": "2e42",
	"./star2.webp": "7f0d",
	"./star2_sm.webp": "7d77",
	"./star3.webp": "2907",
	"./star3_sm.webp": "ebfa",
	"./star4.webp": "e30d",
	"./star4_sm.webp": "00c6",
	"./stars.webp": "bd10",
	"./stars_sm.webp": "25c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d84d";